import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {retainActions} from "../../../../../../_actions";
import {CampaignsMetricsBuilder} from "../objects/CampaignsMetricsBuilder";
import _ from "lodash";
import {getCampaignRevenue} from "../CampaignUtils";

export default function ({startDate, endDate}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(retainActions.getCompanyRetainMetrics({startDate, endDate}));
    }, [startDate, endDate]);

    const retainMetrics = useSelector(state => state.retain);
    const loading = retainMetrics.loadingRetainMetrics;
    const campaignsMetrics = retainMetrics.retainMetrics;
    const builder = new CampaignsMetricsBuilder()

    if(!loading) {
        builder.setConversions(_.get(campaignsMetrics, 'conversions') || '-')
        builder.setWinbackRevenue(getCampaignRevenue(_.get(campaignsMetrics, 'winbackRevenue')))
        builder.setAdditionalRevenue(getCampaignRevenue(_.get(campaignsMetrics, 'additionalRevenue')))
        builder.setLtvIncreaseRatio(_.get(campaignsMetrics, 'ltvIncreaseRatio') || '-')
    }

    const data = builder.metrics || {};
    return { loading, data };
}
